var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import clsx from 'clsx';
import { withForwardedRef } from '../utils/helpers/reactHelpers';
const TabListSC = styled.div `
  padding: 0;
  margin-bottom: 0.5rem;
  flex: 0 0 auto;
  display: flex;
  overflow-y: auto;
`;
const TabList = (props) => {
    const { children: childrenProp, forwardedRef, fullWidth, className: classNameProp } = props, others = __rest(props, ["children", "forwardedRef", "fullWidth", "className"]);
    let tabIndex = -1;
    const children = React.Children.map(childrenProp, (child) => {
        if (!React.isValidElement(child)) {
            return null;
        }
        tabIndex += 1;
        return React.cloneElement(child, {
            index: tabIndex,
            fullWidth
        });
    });
    return (React.createElement(TabListSC, Object.assign({ ref: forwardedRef, className: clsx(classNameProp, '_ndsTabList', {
            '_ndsTabList--full-width': fullWidth
        }), role: "tablist" }, others), children));
};
TabList.propTypes = {
    children: PropTypes.node,
    forwardedRef: PropTypes.any,
    className: PropTypes.string,
    fullWidth: PropTypes.bool
};
TabList.defaultProps = {
    children: null,
    forwardedRef: React.createRef(),
    className: undefined,
    fullWidth: false
};
export default withForwardedRef(TabList);
//# sourceMappingURL=TabList.js.map